import { render, staticRenderFns } from "./modalGeneral.vue?vue&type=template&id=23a7dbd8&scoped=true"
import script from "./modalGeneral.vue?vue&type=script&lang=js"
export * from "./modalGeneral.vue?vue&type=script&lang=js"
import style0 from "./modalGeneral.vue?vue&type=style&index=0&id=23a7dbd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a7dbd8",
  null
  
)

export default component.exports